import React, {useEffect, useCallback} from "react";
import {isEmpty} from "lodash";
import {useParams} from "react-router-dom";
import {useDispatch, useSelector} from "react-redux";
import Cells from "../../components/Charts/Containers/Cell/Cells";
import ListView from "../../components/ContentDisplay/ListView";
import SafeView from "../../components/safeView/SafeView";
import {useCleanupOnUnload} from "../../hooks/useCleanupOnUnload";
import {
  requestAlarmHistory,
  requestAlarmHistoryLogs,
  storeAlarmHistoryLogs,
} from "../../redux/Actions/alerts.actions";
import {storeDataExplorerAnalysis} from "../../redux/Actions/data-explorer.actions";
import {getHistoryLogs} from "../../redux/Selectors/alerts.selector";
import {getDataExplorerAnalysis} from "../../redux/Selectors/data-explorer.selectors";
import AlertHistoryCard from "./alertHistoryCard";
import "./AlertHistory.scss";

const LIST_HEADERS = ["timestamp", "message", "type"];

const AlertHistory = () => {
  const {alertId} = useParams();
  const logs = useSelector(getHistoryLogs);
  const analysis = useSelector(getDataExplorerAnalysis);
  const dispatch = useDispatch();

  const cleanup = useCallback(() => {
    dispatch(storeDataExplorerAnalysis({}));
    dispatch(storeAlarmHistoryLogs([]));
  }, [dispatch]);

  useCleanupOnUnload(cleanup);

  useEffect(() => {
    dispatch(requestAlarmHistory(alertId));
    dispatch(requestAlarmHistoryLogs(alertId));
  }, [alertId, dispatch]);

  return (
    <SafeView>
      <div className="alerts--history--container" data-cy={"alert-history"}>
        {!isEmpty(analysis) && (
          <div>
            <Cells
              dashboardId={"history"}
              cells={[analysis]}
              isResizable={false}
              isDraggable={false}
            />
            <hr />
          </div>
        )}
        <h1>Logs</h1>
        <div data-cy={"alert-history-logs"}>
          <ListView
            listItems={logs}
            listHeaders={LIST_HEADERS}
            cardContent={AlertHistoryCard}
          />
        </div>
      </div>
    </SafeView>
  );
};

export default AlertHistory;
